module.exports = __webpack_public_path__ + "img/img-lg-calnorthex.97787adc.png";